
import { FuncionalidadesGeral } from '../../../helpers/funcionalidades'
// Bug 856501: ícones dos cards alinhados ao Figma da página inicial.
import atendimentoTelefonicoIcon from '../../../images/icones-os033/atendimento-telefonico.png'
import atendimentoPresencialIcon from '../../../images/icones-os033/atendimento-presencial.png'
import consultaAtendimentosIcon from '../../../images/icones-os033/consulta-atendimentos.png'
import complementarInformacoesIconSvg from '../../../images/icones-os034/icon-complementar-informacao.svg'

// webpack.config.js usa svg-inline-loader: import de .svg vem como markup inline
// (string), não como URL — precisa virar data URI antes de usar em <img src>.
const complementarInformacoesIcon = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(complementarInformacoesIconSvg)}`

export const options = [
    {
      title: 'Atendimento Telefônico',
      icon: atendimentoTelefonicoIcon,
      description: 'Cadastre novo atendimento telefônico',
      route: '/cadastrar-atendimento?tipo=telefonico',
      order: 1,
      area: 'atendimento',
      funcionalidade: FuncionalidadesGeral.atendimento.novoAtendimentoTelefonico,
    },
    {
      title: 'Atendimento Presencial',
      icon: atendimentoPresencialIcon,
      description: 'Cadastre novo atendimento presencial',
      route: '/cadastrar-atendimento?tipo=presencial',
      order: 2,
      area: 'atendimento',
      funcionalidade: FuncionalidadesGeral.atendimento.novoAtendimentoPresencial,
    },
    {
      // HU-003: Consultar Atendimentos.
      title: 'Consulta de Atendimentos',
      icon: consultaAtendimentosIcon,
      description: 'Consulte atendimentos realizados e retorne um atendimento iniciado.',
      route: '/consultar-atendimentos',
      order: 3,
      area: 'atendimento',
      funcionalidade: FuncionalidadesGeral.atendimento.consultarAtendimentos,
    },
    {
      // HU-031 — item de acesso rápido "Complementação de Informações".
      title: 'Complementação de Informações',
      icon: complementarInformacoesIcon,
      description: 'Complemente informações de uma comunicação.',
      route: '/complementacao',
      order: 4,
      area: 'atendimento',
      funcionalidade: FuncionalidadesGeral.caixaEntrada.complementarInformacao,
    },
  ]
